import { AlertComponent } from '../alertComponent/alert.component';
import { MatDialog, MatSnackBar } from '@angular/material';
var BAppService = (function () {
    function BAppService(dialog, snackBar) {
        this.dialog = dialog;
        this.snackBar = snackBar;
    }
    BAppService.prototype.alert = function (message, title, data) {
        AlertComponent.message = message;
        AlertComponent.title = title;
        return this.dialog.open(AlertComponent, data);
    };
    BAppService.prototype.openSnackBar = function (message) {
        this.snackBar.open(message, 'close', { duration: 3000 });
    };
    return BAppService;
}());
export { BAppService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bApp.service.ts.pre-build-optimizer.js